<template>
  <div>
    <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :collapse="isCollapse">
      <Drawing :data="menu" />
    </el-menu>
  </div>
</template>

<script>
import Drawing from "../Components/SideBar/Drawing.vue";
export default {
  components: { Drawing },
  name: "sliderBar",
  component: {},
  data() {
    return {
      //展开 还是折叠
      isCollapse: false,
      activeMenu: "",
      menu: [
        {
          index: "1",
          path: "/PrimarySurface",
          name: "PrimarySurface",
          label: "企业服务",
          icon: "s-home",
        },
        {
          index: "2",
          path: "/",
          name: "/",
          label: "信用服务",
          icon: "s-platform",
          children: [
            {
              index: "2-1",
              path: "/creditService",
              name: "creditService",
              label: "信用服务申请",
            },
            // {
            //   index: "2-2",
            //   path: "/enterpriseCreditRating",
            //   name: "enterpriseCreditRating",
            //   label: "企业信用评价",
            // },
            {
              index: "2-2",
              path: "/PayJudgment",
              name: "PayJudgment",
              label: "企业信用评价",
            },
            {
              index: "2-3",
              path: "/SupplierAccesslist",
              name: "SupplierAccesslist",
              label: "供应商准入",
            },
            {
              index: "2-4",
              path: "/enterpriseBasicCreditReport",
              name: "enterpriseBasicCreditReport",
              label: "基础信用报告",
            },
            {
              index: "2-5",
              path: "/electronicGuaranteeCreditRiskReport",
              name: "electronicGuaranteeCreditRiskReport",
              label: "保函信用报告",
            },
            {
              index: "2-6",
              path: "/businessRiskScreeningReport",
              name: "businessRiskScreeningReport",
              label: "风险筛查报告",
            },
            {
              index: "2-7",
              path: "/smeAssistanceLoanAnalysisReport",
              name: "smeAssistanceLoanAnalysisReport",
              label: "助贷分析报告",
            },
          ],
        },
        {
          index: "3",
          path: "/",
          name: "",
          label: "电子保函",
          icon: "s-finance",
          children: [
            {
              index: "3-1",
              path: "/electronicGuarantee",
              name: "electronicGuarantee",
              label: "保函申请",
            },
            // {
            //   index: "3-2",
            //   path: "/GuaranteeFind",
            //   name: "GuaranteeFind",
            //   label: "电子保函查验",
            // },
            {
              index: "3-3",
              path: "/electronicGuaranRecord",
              name: "electronicGuaranRecord",
              label: "保函记录",
            },
            // {
            //   index: "3-4",
            //   path: "/tianan",
            //   name: "tianan",
            //   label: "外部保函记录",
            // },
          ],
        },
        {
          index: "4",
          path: "/",
          name: "",
          label: "金融产品",
          icon: "s-marketing",
          children: [
            {
              index: "4-1",
              path: "/financialProducts",
              name: "financialProducts",
              label: "金融产品申请",
            },
            {
              index: "4-2",
              path: "/applicationRecord",
              name: "applicationRecord",
              label: "申请记录",
            },
          ],
        },
        {
          index: "5",
          path: "/financingDemand",
          name: "financingDemand",
          label: "融资需求",
          icon: "s-order",
        },
        {
          index: "6",
          path: "/",
          name: "",
          label: "订单管理",
          icon: "s-custom",
          children: [
            {
              index: "6-1",
              path: "/MyOrder",
              name: "MyOrder",
              label: "我的订单",
              // icon: "s-custom",
            },
            {
              index: "6-2",
              path: "/Myinvoice",
              name: "Myinvoice",
              label: "我的发票",
              // icon: "s-custom",
            },
          ],
        },
        {
          index: "7",
          path: "/hmqA",
          name: "hmqA",
          label: "常见问题",
          icon: "s-custom",
        },
        // {
        //   index: "3",
        //   path: "/",
        //   name: "/",
        //   label: "综合服务",
        //   icon: "s-data",
        //   children: [
        //     {
        //       index: "3-1",
        //       path: "/InFormaTionDisplay",
        //       name: "InFormaTionDisplay",
        //       label: "个人中心",
        //     },
        //     {
        //       index: "3-2",
        //       path: "/PrimarySurface",
        //       name: "PrimarySurface",
        //       label: "企业信息",
        //     },
        //     {
        //       index: "3-3",
        //       path: "/MyOrder",
        //       name: "MyOrder",
        //       label: "我的订单",
        //     },
        //   ],
        // },

        // {
        //   index: "4",
        //   path: "/",
        //   name: "",
        //   label: "企业信用评价",
        //   icon: "s-claim",
        //   children: [
        //     {
        //       index: "4-1",
        //       path: "/EnterApplicaTion",
        //       name: "EnterApplicaTion",
        //       label: "企业信用评价申请",
        //     },
        //     {
        //       index: "4-2",
        //       path: "/PayJudgment",
        //       name: "PayJudgment",
        //       label: "申请记录",
        //     },
        //   ],
        // },
        // {
        //   index: "1",
        //   path: "/SupplierAccesslist",
        //   name: "SupplierAccesslist",
        //   label: "综合供应商准入",
        //   icon: "s-home",
        // },
      ],
    };
  },

  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
  },
};
</script>
<style scoped>
>>> .el-menu-item.is-active {
  color: #009589 !important;
  border-left: 5px solid #009589;
  border-bottom-color: #009589 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/components/SliderBar.vue